/**
 * Main JS file for project.
 */
'use strict';



$(document).ready(function() {

  $(window).scrollTop(0);

  $(".slide").css("height",($(window).height()));

  $( window ).resize(function() {
    $(".slide").css("height",($(window).height()));
  });

  $(".audio-links").hide();

  $(".footer-tmp").addClass("invisible");

  for (var i = 1 ; i < 5 ; i++) {
    drawSnowflakes(i);
  }

  // Find all iframes
  var $iframes = $( "iframe" );
   
  // Find &#x26; save the aspect ratio for all iframes
  $iframes.each(function () {
    $( this ).data( "ratio", this.height / this.width )
      // Remove the hardcoded width &#x26; height attributes
      .removeAttr( "width" )
      .removeAttr( "height" );
  });
   
  // Resize the iframes when the window is resized
  $( window ).resize( function () {
    $iframes.each( function() {
      // Get the parent container&#x27;s width
      var width = $( this ).parent().width();
      $( this ).width( width )
        .height( width * $( this ).data( "ratio" ) );
    });
  // Resize to fix all iframes on page load.
  }).resize();

  var SLIDE = 0, PLAY = true;

  var timer;

  var initialized = {1:false, 2:false, 3:false, 4:false, 5:false, 6:false, 7:false, 8:false, 9:false, 10:false, 11:false, 12:false, 13:false};
  var timestampsOld = [25, 39, 57, 70, 86, 99, 131, 146, 155, 158, 165, 169, 194, 198, 205, 214, 218, 234, 252, 262, 270, 283, 291, 300, 346, 354, 362, 421];
  var canvasWidth = 100;
  var audioEl = document.getElementById("audio");
  var canvas = document.getElementById("progress").getContext('2d');
  var ctrl = document.getElementById('audioControl');
  var currentTimer = null;

  audioEl.removeAttribute('autoplay');

  canvas.fillStyle = "#36454f";

  audioEl.addEventListener('loadedmetadata', function() {
    var duration = audioEl.duration
    var currentTime = audioEl.currentTime
    document.getElementById("duration").innerHTML = convertElapsedTime(duration)
    document.getElementById("current-time").innerHTML = convertElapsedTime(currentTime)
    canvas.fillRect(0, 0, canvasWidth, 5);
  });

  audioEl.addEventListener('timeupdate', function() {
    updateBar();
  });

  $("#audioControl").on("click", function() {
    togglePlaying();
  });

  $("body").addClass("noScroll");

  $("#snowkit_button").on("click", function() {
    document.getElementById("snowkit").scrollIntoView(true);
    $("body").removeClass("noScroll");
    for (var i = 1 ; i <= 38 ; i++) {
    $(".slide-"+i).removeClass("invisible");
    }
  });

//  $('#snowkit-button').click(function(){
//    var jump = $(this).attr('href');
//    var new_position = $('#'+jump).offset();
//    window.scrollTo(new_position.left,new_position.top);
//    return false;
//  });

  for (var i = 1 ; i <= 38 ; i++) {
    $(".slide-"+i).addClass("invisible");
  }

  //$(".slide-0"+i).css("visibility","visible");

  $(".audio-btn-1").on("click", function() {
    $("body").removeClass("noScroll");
    SLIDE = 1;
    $(".audio-btn-1").fadeOut("slow");
    $(".sound-guide").fadeOut("slow");

    
    $(".slide-1").removeClass("invisible");
    
    //$(window).scrollTop($(".slide-1").offset().top);
    $('html,body').animate({
        scrollTop: $(".slide-1").offset().top},
        'slow');
    $(".slide-0").addClass("invisible");
    $("body").addClass("noScroll");
    
    $(".audio-links").fadeIn("slow");
    startTimer();
    togglePlaying();
    
  })


  function Timer(callback, delay) {
    var timerId, start, remaining = delay;

    this.pause = function() {
        window.clearTimeout(timerId);
        remaining -= new Date() - start;
    };

    this.resume = function() {
        start = new Date();
        window.clearTimeout(timerId);
        timerId = window.setTimeout(callback, remaining);
    };

    this.resume();
  }
  
  var timestamps = [25, 40, 47, 54, 72, 76, 80, 86, 98, 132, 143, 152, 160, 170, 181, 183, 185, 191, 198, 205, 217, 243, 253, 259, 263, 279, 304, 318, 326, 331, 348, 384, 422, 432, 444];

  function slide(num) {
    SLIDE = num;
    
    $(".slide-"+SLIDE).removeClass("invisible");
    $("body").removeClass("noScroll");
    $(window).scrollTop($(".slide-"+SLIDE).offset().top);
    $(".slide-"+(SLIDE-1)).addClass("invisible");
    $("body").addClass("noScroll");
    $(".slide-"+(SLIDE-1)).addClass("invisible");
  }

  function slideLast() {
    $("body").removeClass("noScroll");
    $('html,body').animate({
        scrollTop: $(".slide-37").offset().top},
        'slow');
  }

  function startTimer() {

    var ctr = 2; 
    var idx = 0;
    var tmp = timestamps[idx]*1000;

    var t1 = currentTimer = new Timer(function() {
      slide(ctr);
      newTimer(0);
    }, tmp);

    function newTimer(idx) {

      if(ctr <= 38) {

        var msec;
        if(idx != 0) {
          msec = (timestamps[idx] - timestamps[idx-1]) * 1000;
        } else {
          msec = timestamps[idx];
        }

        console.log("new timer: ",msec)
        currentTimer = new Timer(function() {
          slide(ctr);
          ctr += 1; 
          idx += 1;
          newTimer(idx);
        }, msec);

      } else {
        
        $(".slide").removeClass("invisible");
        $(".footer-tmp").removeClass("invisible"); 
        $("body").removeClass("noScroll");

        return false;

      }

    }

  }

  function lockScroll() {
    // lock scroll position, but retain settings for later
    var scrollPosition = [
      self.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft,
      self.pageYOffset || document.documentElement.scrollTop  || document.body.scrollTop
    ];
    var html = jQuery('html'); // it would make more sense to apply this to body, but IE7 won't have that
    html.data('scroll-position', scrollPosition);
    html.data('previous-overflow', html.css('overflow'));
    html.css('overflow', 'hidden');
    window.scrollTo(scrollPosition[0], scrollPosition[1]);

  }

  function unlockScroll() {
    var html = jQuery('html');
    var scrollPosition = html.data('scroll-position');
    html.css('overflow', html.data('previous-overflow'));
    window.scrollTo(scrollPosition[0], scrollPosition[1])
  }

  function startTimer_pause() {

    timer = new Timer(function() {
        slide_pause(0);
    }, timestamps[0]*1000);

    // timer.pause();
    // timer.resume();

  }

  function slide_pause(n) {

    if (n < timestamps.length) {

      SLIDE += 1;
      $(".slide-"+SLIDE).removeClass("invisible");
      $('html,body').animate({
          scrollTop: $(".slide-"+SLIDE).offset().top},
          'slow');
      $(".slide-"+(SLIDE-1)).addClass("invisible");
      n += 1;

      (function() {
        timer = new Timer(function() {
          console.log("slide")
          slide(n);
        }, (timestamps[n]*1000));
      })
    } else {
      console.log("end timestamp")
    }

  }

  function togglePlaying() {

    var play = ctrl.innerHTML === '<i class="fa fa-play"></i>'
    var method

    if (play) {
      ctrl.innerHTML = '<i class="fa fa-pause"></i>'
      method = 'play'
      currentTimer.resume();
    } else {
      ctrl.innerHTML = '<i class="fa fa-play"></i>'
      method = 'pause'
      currentTimer.pause();
    }

    audioEl[method]()

  }

  function updateBar() {
    canvas.clearRect(0, 0, canvasWidth, 5)
    canvas.fillStyle = "#36454f";
    canvas.fillRect(0, 0, canvasWidth, 5)
    
    var currentTime = audioEl.currentTime
    var duration = audioEl.duration
    
    if (currentTime === duration) {
      ctrl.innerHTML = '<i class="fa fa-play"></i>'
    }
    
    document.getElementById("current-time").innerHTML = convertElapsedTime(currentTime)
    
    var percentage = currentTime / duration
    var progress = (canvasWidth * percentage)
    canvas.fillStyle = "#DE1E3D"
    canvas.fillRect(0, 0, progress, 5)
  }

  function convertElapsedTime(inputSeconds) {
    var seconds = Math.floor(inputSeconds % 60)
    if (seconds < 10) {
      seconds = "0" + seconds
    }
    var minutes = Math.floor(inputSeconds / 60)
    return minutes + ":" + seconds
  }


});




function drawSnowflakes(i) {

  var width = 250,
    height = 250;

  var svg = d3.select(".card-"+i).append("svg")
    .attr("width", width)
    .attr("height", height);

  var g = svg.append("g");

  var img = g.append("svg:image")
    .attr("xlink:href", "assets/images/snowflakes/snowflake-" + i + ".svg")
    .attr("width", 180)
    .attr("height", 180)
    .attr("x", 45)
    .attr("y",40)
    //.attr("scale","10");

  var ctr = 0;

  repeat();

  function repeat() {

    img
      .transition()
      .duration(10000)
      .attrTween("transform", tween)
      .on("end", repeat);

    function tween(d, i, a) {
      if(ctr % 2 == 0) {
        return d3.interpolateString("rotate(-355, 150, 130)", "rotate(60, 150, 130)");
      } else {
        return d3.interpolateString("rotate(60, 150, 130)", "rotate(-355, 150, 130)");
      }
    }

    ctr += 1;

  }

}





// WEBPACK FOOTER //
// ./app/index.js